import { GsFormField } from 'libs/shared/src/components';

export const ACTIVE_SCHEMA_FIELDS: GsFormField<never>[] = [
  {
    formControlName: 'shown',
    label: 'schema.active.show',
    type: 'checkbox',
    isResponsive: true,
    default: { default: true },
    groupingName: 'schema.active.shown'
  },
  {
    formControlName: 'activeFrom',
    label: 'schema.active.from',
    type: 'datepicker',
    nullable: true,
    validations: [
      {
        if: {
          chaining: 'or',
          args: [
            {
              formControlName: 'activeUntil',
              operator: '==',
              value: null
            },
            {
              formControlName: 'activeFrom',
              operator: '>',
              value: '{activeUntil}'
            }
          ]
        },
        messages: {
          invalid: 'schema.active.dateBeforeUntil'
        }
      }
    ]
  },
  {
    formControlName: 'activeUntil',
    label: 'schema.active.until',
    type: 'datepicker',
    nullable: true,
    validations: [
      {
        if: {
          chaining: 'or',
          args: [
            {
              formControlName: 'activeFrom',
              operator: '==',
              value: null
            },
            {
              formControlName: 'activeUntil',
              operator: '<',
              value: '{activeFrom}'
            }
          ]
        },
        messages: {
          invalid: 'schema.active.dateAfterFrom'
        }
      }
    ]
  }
];
